import { Injectable } from '@angular/core';

@Injectable()

export class SortService {

  private productoSort = ['Soja', 'Maiz', 'Trigo', 'Girasol', 'Sorgo'];
  private entregaSort = ['Entregado', 'A Entregar', 'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];

  chipsSelectProdSort(object) {
    if (object.length) {
      return object.sort((a, b) => {
        const a_Order = this.productoSort.indexOf(a.ItemLabel) !== -1 ? this.productoSort.indexOf(a.ItemLabel) : this.productoSort.length;
        const b_Order = this.productoSort.indexOf(b.ItemLabel) !== -1 ? this.productoSort.indexOf(b.ItemLabel) : this.productoSort.length;
        return a_Order - b_Order;
      });
    } else {
      return [];
    }
  }

  chipsSelectCosechaSort(object) {
    if (object.length) {
      return object.sort((a, b) => {
        const a_components = a.ItemLabel.includes('/') ? a.ItemLabel.split('/') : [a.ItemLabel.length.toString()];
        const b_components = b.ItemLabel.includes('/') ? b.ItemLabel.split('/') : [a.ItemLabel.length.toString()];
        return b_components[0] - a_components[0];
      });
    } else {
      return [];
    }
  }

  chipsSelectEntregaSort(object) {
    if (object.length) {
      return object.sort((a, b) => {
        const namesA = a.ItemLabel.split('-');
        const namesB = b.ItemLabel.split('-');

        if (namesA.length + namesB.length === 2) {
          return this.entregaSort.indexOf(namesA[0]) - this.entregaSort.indexOf(namesB[0]);
        } else if (namesA.length !== namesB.length) {
          return namesA.length - namesB.length;
        } else {
          if (namesA[1] === namesB[1]) {
            return this.entregaSort.indexOf(namesA[0]) - this.entregaSort.indexOf(namesB[0]);
          } else {
            return Number(namesA[1]) - Number(namesB[1]);
          }
        }
      });
    } else {
      return [];
    }
  }

  chipsSelectIDSort(object, inverse = false) {
    if (object.length) {
      return object.sort((a, b) => {
        if (inverse) {
          return b.ID - a.ID;
        } else {
          return a.ID - b.ID;
        }
      });
    } else {
      return [];
    }
  }

  chipsSelectLabelSort(object, inverse = false) {
    if (object.length) {
      return object.sort((a, b) => {
        if (inverse) {
          return b.ItemLabel - a.ItemLabel;
        } else {
          return a.ItemLabel - b.ItemLabel;
        }
      });
    } else {
      return [];
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/sort-service.ts